import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: 'white',
  },
  gutter: {
    width: '100%',
  },
});
